import type { TypographyType } from '@/ui/Typography/types';
import { tokenToVariable } from '@/ui/utils/tokenToVariable';
import styles from './Typography.module.css';

const Typography = {} as TypographyType;

Typography.Display = ({ color, align, level = 1, ...props }) => (
    <div
        className={styles[`d-${level}`]}
        style={{
            ...(color ? { color: tokenToVariable(color) } : {}),
            ...(align ? { textAlign: align } : {})
        }}
        {...props}
    />
);

Typography.Heading = ({ color, align, level = 1, ...props }) => {
    switch (level) {
        case 1:
            return (
                <h1
                    className={styles['h-1']}
                    style={{
                        ...(color ? { color: tokenToVariable(color) } : {}),
                        ...(align ? { textAlign: align } : {})
                    }}
                    {...props}
                />
            );
        case 2:
            return (
                <h2
                    className={styles['h-2']}
                    style={{
                        ...(color ? { color: tokenToVariable(color) } : {}),
                        ...(align ? { textAlign: align } : {})
                    }}
                    {...props}
                />
            );
        case 3:
            return (
                <h3
                    className={styles['h-3']}
                    style={{
                        ...(color ? { color: tokenToVariable(color) } : {}),
                        ...(align ? { textAlign: align } : {})
                    }}
                    {...props}
                />
            );
        case 4:
            return (
                <h4
                    className={styles['h-4']}
                    style={{
                        ...(color ? { color: tokenToVariable(color) } : {}),
                        ...(align ? { textAlign: align } : {})
                    }}
                    {...props}
                />
            );
        case 5:
            return (
                <h5
                    className={styles['h-5']}
                    style={{
                        ...(color ? { color: tokenToVariable(color) } : {}),
                        ...(align ? { textAlign: align } : {})
                    }}
                    {...props}
                />
            );
    }
};

Typography.Paragraph = ({ color, align, level = 1, ...props }) => (
    <p
        className={styles[`p-${level}`]}
        style={{
            ...(color ? { color: tokenToVariable(color) } : {}),
            ...(align ? { textAlign: align } : {})
        }}
        {...props}
    />
);

Typography.Action = ({ color, align, level = 1, ...props }) => (
    <div
        className={styles[`a-${level}`]}
        style={{
            ...(color ? { color: tokenToVariable(color) } : {}),
            ...(align ? { textAlign: align } : {})
        }}
        {...props}
    />
);

Typography.Description = ({ color, align, level = 1, ...props }) => (
    <div
        className={styles[`ds-${level}`]}
        style={{
            ...(color ? { color: tokenToVariable(color) } : {}),
            ...(align ? { textAlign: align } : {})
        }}
        {...props}
    />
);

export { Typography };
